<div class="gb-limit-width">
  <h1 translate="STAFF.AWS_TOOLS.TITLE"></h1>

  <div class="tool-section">
    <h2 translate="STAFF.AWS_TOOLS.CLOUDFRONT.HEADING"></h2>
    <div class="description-container">
      <p [innerHtml]="'STAFF.AWS_TOOLS.CLOUDFRONT.DESCRIPTION' | translate"></p>
      <p [innerHtml]="'STAFF.AWS_TOOLS.CLOUDFRONT.NOTE' | translate"></p>
    </div>
    <div class="button-container">
      <button (click)="createInvalidation()" mat-flat-button>
        <div class="button-inner">
          <gb-icon icon="cloud-done"></gb-icon>
          <span translate="STAFF.AWS_TOOLS.CLOUDFRONT.BUTTON"></span>
        </div>
      </button>
    </div>
  </div>

  <div class="tool-section">
    <h2 translate="STAFF.AWS_TOOLS.HELP_CENTER.HEADING"></h2>
    <div class="description-container">
      <p [innerHtml]="'STAFF.AWS_TOOLS.HELP_CENTER.DESCRIPTION' | translate"></p>
    </div>
    <div class="button-container">
      <button (click)="syncKnowledgeSources()" mat-flat-button>
        <div class="button-inner">
          <gb-icon icon="sync"></gb-icon>
          <span translate="STAFF.AWS_TOOLS.HELP_CENTER.BUTTON"></span>
        </div>
      </button>
    </div>
  </div>
</div>
